module.exports = __webpack_public_path__ + "static/img/avatar-1.d0137f23.jpg";